export default "__VITE_ASSET__Dlg48eOo__"